import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const faqList = createAsyncThunk('faqList', async (data) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `faq`,
            headers: { "Content-Type": "application/json" }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const faqListSlice = createSlice({
    name: 'faqList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(faqList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                state.data = [];
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = [];
            }
        });
        builder.addCase(faqList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default faqListSlice.reducer; 